import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Pastor from "@/pages/Pastor";
import Sermons from "@/pages/Sermons";
import Events from "@/pages/Events";
import Ministries from "@/pages/Ministries";
import Give from "@/pages/Give";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import House2House from "@/pages/House2House";
import Friends from "@/pages/Friends";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

function SiteLayout() {
    return (
        <Layout>
            <Outlet />
        </Layout>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <ScrollToTop />
                    <Toaster position="top-center" richColors />
                    <Routes>
                        <Route element={<SiteLayout />}>
                            <Route path="/" element={<Home />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/pastor" element={<Pastor />} />
                            <Route path="/sermons" element={<Sermons />} />
                            <Route path="/events" element={<Events />} />
                            <Route path="/ministries" element={<Ministries />} />
                            <Route path="/house2house" element={<House2House />} />
                            <Route path="/friends" element={<Friends />} />
                            <Route path="/give" element={<Give />} />
                            <Route path="/contact" element={<Contact />} />
                        </Route>
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<AdminDashboard />} />
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
